<template>
  <div :class="[ bordered ? 'container-bordered' : `container container-${this.theme}` ]">
    <a-radio-group :value="currentLocale" size="small" @change="onLangChange">
      <template v-for="locale in locales">
        <a-radio-button :value="locale.key" :key="locale.key">
          {{ locale.label }}
        </a-radio-button>
      </template>
    </a-radio-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    bordered: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'dark'
    }
  },
  data() {
    return {
      locales: [{
        key: 'zh-CN',
        label: '中 文'
      },{
        key: 'en-US',
        label: 'Eng'
      }],
    }
  },
  computed: {
    currentLocale() {
      const locale = this.$store.getters.lang.lang
      return locale
    }
  },
  methods: {
    ...mapActions(['setLang']),
    onLangChange(e) {
      const lang = e.target.value
      this.setLang(lang)
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/components/theme.less";

.container {

  .ant-radio-button-wrapper:not(:first-child)::before {
    position: absolute;
    top: 3px;
    left: 2px;
    display: block;
    box-sizing: content-box;
    width: 1px;
    height: 15px;
    padding: 1px 0;
    background-color: #d9d9d9;
    transition: background-color 0.3s;
    content: '';
  }

  .ant-radio-button-wrapper {
    border: none;
    background: transparent;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    width: 60px;
    text-align: center;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    font-weight: 600;
    font-size: 16px;
  }
}

.container-bordered {

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background: @primary-color-active;
  }
}

.container-dark {
  .ant-radio-button-wrapper {
    color: #eee;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
  }
}

.container-light {
  .ant-radio-button-wrapper {
    color: #999;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #333;
  }
}

</style>
